import { F0AvatarPerson, F0AvatarTeam } from '@factorialco/f0-react'

import buildUrl from 'modules/core/lib/buildUrl'

import type { ApprovalsV2TimelineEntryAssignee, TimelineItemEmployeeFragment } from './types'
import styles from './styles.module.css'

interface OverflowTooltipProps {
  assignees: ApprovalsV2TimelineEntryAssignee[]
  employees: TimelineItemEmployeeFragment[]
}

const OverflowTooltip = ({ assignees, employees }: OverflowTooltipProps) => (
  <div className={styles.overflowTooltipScroll}>
    {assignees.map((assignee, index) => {
      if (assignee.peopleGroupName) {
        return (
          <div
            key={`overflow-${assignee.peopleGroupName}-${index}`}
            className={styles.overflowTooltipRow}
          >
            <F0AvatarTeam name={assignee.peopleGroupName} size="xsmall" />
            <span className={styles.overflowTooltipName}>{assignee.peopleGroupName}</span>
          </div>
        )
      }

      if (assignee.employeeId == null) return null

      const employee = employees.find((emp) => String(emp?.id) === String(assignee.employeeId))
      if (!employee) return null

      return (
        <div key={`overflow-${assignee.employeeId}-${index}`} className={styles.overflowTooltipRow}>
          <F0AvatarPerson
            src={buildUrl(employee.avatar?.url)}
            firstName={employee.firstName || ''}
            lastName={employee.lastName || ''}
            size="xsmall"
          />
          <span className={styles.overflowTooltipName}>{employee.fullName}</span>
        </div>
      )
    })}
  </div>
)

export default OverflowTooltip
